import { earnPointsFromBill } from "@/api/bill-api";
import PointStorage from '../storage/point.storage';

const bill = {
  namespaced: true,
  state: {
    uniqueOrderCode: null,
    earnPoints: null,
    isShowEarnPointsFromBill: false,
  },
  getters: {
    isShowEarnPointsFromBill(state) {
      return state.isShowEarnPointsFromBill;
    },
    uniqueOrderCode(state) {
      return PointStorage.pointsInfo? PointStorage.pointsInfo.uoc:null
    },
    earnPoints(state) {
      return PointStorage.pointsInfo? PointStorage.pointsInfo.points:null
    },
  },
  mutations: {
    SET_UOC(state, payload) {
      state.uniqueOrderCode = payload.uoc;
      state.earnPoints = payload.points;
      PointStorage.pointsInfo = payload
    },
    OPEN_EARN_BILL_DIALOG(state) {
      const register = localStorage.getItem('register-points')
      if(PointStorage.pointsInfo || register)
        state.isShowEarnPointsFromBill = true;
    },
    CLOSE_EARN_BILL_DIALOG(state) {
      state.uniqueOrderCode = null;
      state.earnPoints = null;
      PointStorage.clear()
      state.isShowEarnPointsFromBill = false;
    },
  },
  actions: {
    async earnPointsFromBill({ state }) {
      return await earnPointsFromBill();
    },
  },
}

export default bill;
